import { FETCH_UPCOMING_REQUESTED } from "./actions";
import { UPCOMING_LOADED } from "./actions";
import { UPCOMING_ERROR } from "./actions";
import { LOAD_MORE } from "./actions";
import { LOAD_MORE_REQUESTED } from "./actions";

const defaultState = {
  moviesUpcoming: [],
  loading: true,
  error: null,
  page: 1
};

export const upcomingReducer = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_UPCOMING_REQUESTED:
      return {
        moviesUpcoming: [],
        loading: true,
        error: null,
        page: state.page
      };

    case UPCOMING_LOADED:
      return {
        moviesUpcoming: action.payload,
        loading: false,
        error: null,
        page: state.page
      };

    case UPCOMING_ERROR:
      return {
        moviesUpcoming: [],
        loading: false,
        error: true,
        page: state.page
      };
    case LOAD_MORE_REQUESTED:
      return {
        moviesUpcoming: state.moviesUpcoming,
        loading: false,
        error: null,
        page: state.page + 1
      };
    case LOAD_MORE:
      return {
        moviesUpcoming: [...state.moviesUpcoming, ...action.payload],
        loading: false,
        error: null,
        page: state.page
      };

    default:
      return state;
  }
};
